import { processSteps } from "../data/mock";
import { ClipboardCheck, PenTool, Hammer, HeadphonesIcon, ArrowRight } from "lucide-react";

const stepIcons = [ClipboardCheck, PenTool, Hammer, HeadphonesIcon];

export const ProcessSection = () => {
  return (
    <section id="process" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-brand-50 rounded-full px-4 py-1.5 mb-5 border border-brand-100">
            <ClipboardCheck className="w-4 h-4 text-brand-600" />
            <span className="text-sm font-medium text-brand-700">Our Process</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            How We Work
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto text-base">
            A systematic approach to every project — ensuring quality, transparency, and timely delivery at every stage.
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {processSteps.map((step, index) => {
            const IconComp = stepIcons[index] || ClipboardCheck;
            return (
              <div key={index} className="relative">
                <div className="group bg-white rounded-2xl p-6 border border-slate-100 hover:border-brand-200 hover:shadow-lg transition-all duration-300 h-full">
                  {/* Step number */}
                  <div className="flex items-center justify-between mb-5">
                    <div className="w-12 h-12 rounded-xl bg-brand-600 flex items-center justify-center shadow-md shadow-brand-200">
                      <IconComp className="w-5 h-5 text-white" />
                    </div>
                    <span className="text-4xl font-bold text-slate-100 group-hover:text-brand-50 transition-colors select-none">
                      {String(step.step).padStart(2, "0")}
                    </span>
                  </div>

                  <h3 className="text-lg font-semibold text-slate-800 mb-2.5">
                    {step.title}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Arrow connector (hidden on last item and mobile) */}
                {index < 3 && (
                  <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-6 h-6 rounded-full bg-brand-100 items-center justify-center">
                    <ArrowRight className="w-3.5 h-3.5 text-brand-500" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
